import Card from './ui/Card';
import Icon from './ui/Icon';
import Reveal from './ui/Reveal';
import { cohortFacts, cohortTimeline } from '../data/content';

export default function Cohort() {
  return (
    <section id="cohort">
      <div className="wrap">
        <Reveal className="center narrow">
          <span className="eyebrow">The cohort</span>
          <h2 className="h-sec">How the program is structured.</h2>
          <p className="lede mt-m">
            A six-week live coaching experience where every session builds on the last, allowing the
            entire cohort to progress together.
          </p>
        </Reveal>

        <div className="grid4 mt-l">
          {cohortFacts.map((fact, i) => (
            <Reveal key={fact.title} delay={i}>
              <Card>
                <div className="ic-tile">
                  <Icon name={fact.icon} />
                </div>
                <h4>{fact.title}</h4>
                <p>{fact.body}</p>
              </Card>
            </Reveal>
          ))}
        </div>

        <div className="split mt-l" style={{ marginTop: 64 }}>
          <Reveal>
            <h3 className="h-sub">Every session is designed around four pillars.</h3>
            <p className="mt-m">
              Every 90-minute session combines <b>technical concepts</b>,{' '}
              <b>practical LNG scenarios</b>, <b>live Q&amp;A</b>, and <b>direct coaching</b>. Each
              element is designed to build your confidence, strengthen your technical judgment, and
              help you apply what you learn in real-world LNG operations.
            </p>
            <p>
              From the first live session to the final coaching sessions, you&rsquo;ll progress
              alongside a small cohort, building your capability week by week.
            </p>
          </Reveal>

          <Reveal delay={1}>
            <div className="card timeline">
              {cohortTimeline.map((row) => (
                <div className="timeline-row" key={row.label}>
                  <div>
                    <div className="tl-label">{row.label}</div>
                    <div className="tl-note">{row.note}</div>
                  </div>
                  <div className="tl-when">
                    {row.when}
                    {row.time && (
                      <>
                        <br />
                        <span>{row.time}</span>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
